import { Auth, Users, firebase } from "./index";

const providers = {
  google: new firebase.auth.GoogleAuthProvider(),
  github: new firebase.auth.GithubAuthProvider()
};

const onStateChanged = (onLoggedIn, onLoggedOut) => {
  Auth.onAuthStateChanged(async user => {
    if (!user) return onLoggedOut();
    Users.doc(user.uid)
      .get()
      .then(userDoc => {
        onLoggedIn({
          id: user.uid, ref: user, role: [],
          ...userDoc.data()
        });
      });
  });
};

const logout = () => {
  return new Promise(resolve => {
    Auth.signOut()
      .then(response => resolve([null, response]))
      .catch(error => resolve([error]));
  });
};

const login = async ({ email, password }) => {
  return new Promise(resolve => {
    Auth.signInWithEmailAndPassword(email, password)
      .then(user => resolve([null, user]))
      .catch(async error => {

        let users = await Users
          .where('email', '==', email)
          .where('password', '==', password).get()

        if (users.empty) return resolve([error])

        return resolve(await register(
          {
            ref: users.docs[0].ref,
            ...users.docs[0].data()
          },
          { deleteOld: true }
        ))
      });
  });
};

const loginWithGoogle = async () => {
  return new Promise(resolve => {
    Auth.signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(user => resolve([null, user]))
      .catch(error => resolve([error]));
  });
};

const loginWithPopup = async provider => {
  return new Promise(resolve => {
    Auth.signInWithPopup(providers[provider])
      .then(user => resolve([null, user]))
      .catch(error => resolve([error]));
  });
};

const register = ({ email, password, ...data }, config = {}) => {
  const { deleteOld = false } = config
  return new Promise(resolve => {
    Auth.createUserWithEmailAndPassword(email, password)
      .then(async response => {
        const userData = { id: response.user.uid, email, ...data };
        if (deleteOld && data.ref) {
          await data.ref.delete()
          delete userData.ref
        }
        if (userData.password) delete userData.password
        console.log('register', data, userData)

        Users.doc(response.user.uid).set(userData);
        return resolve([null, userData]);
      })
      .catch(error => resolve([error]));
  });
};

export default {
  login,
  logout,
  register,
  onStateChanged,
  loginWithGoogle,
  loginWithPopup
};
